import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function OrderFilterModal({ show, onHide, filters, onChange }) {
    const { t } = useTranslation();
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t("Filter Orders")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>{t("Payment Gateway")}</label>
                        <select className="form-control" name="payment_gateway" value={filters.payment_gateway} onChange={onChange}>
                            <option value="">{t("All")}</option>
                            <option value="cash_on_delivery">{t("Cash On Delivery")}</option>
                            <option value="send_receipt">{t("Send Receipt")}</option>
                            <option value="paymob_card_gateway">{t("Paymob Card Gateway")}</option>
                            <option value="paymob_wallet_gateway">{t("Paymob Wallet Gateway")}</option>
                        </select>
                    </div>
                    <div className="form-group col-md-6">
                        <label>{t("Refund Status")}</label>
                        <select className="form-control" name="refund_status" value={filters.refund_status} onChange={onChange}>
                            <option value="">{t("All")}</option>
                            <option value="0">{t("Pending")}</option>
                            <option value="1">{t("Paid")}</option>
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>{t("Order Status")}</label>
                        <select className="form-control" name="status" value={filters.status} onChange={onChange}>
                            <option value="">{t("All")}</option>
                            <option value="0">{t("Pending")}</option>
                            <option value="1">{t("Active")}</option>
                            <option value="2">{t("Delivery")}</option>
                            <option value="3">{t("Complete")}</option>
                        </select>
                    </div>
                    <div className="form-group col-md-6">
                        <label>{t("Payment Status")}</label>
                        <select className="form-control" name="payment_status" value={filters.payment_status} onChange={onChange}>
                            <option value="">{t("All")}</option>
                            <option value="pending">{t("Pending")}</option>
                            <option value="complete">{t("Complete")}</option>
                            <option value="failed">{t("Failed")}</option>
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>{t("Start Date")}</label>
                        <input type="date" className="form-control" name="start_date" value={filters.start_date} onChange={onChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label>{t("End Date")}</label>
                        <input type="date" className="form-control" name="end_date" value={filters.end_date} onChange={onChange} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}